import script from "./AppClientSchoolLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AppClientSchoolLayout.vue?vue&type=script&setup=true&lang=js"

export default script